import { createIntl } from '@alilc/lowcode-editor-core';
import enUS from './en-US.json';
import zhCN from './zh-CN.json';
var _ref = (createIntl === null || createIntl === void 0 ? void 0 : createIntl({
    'en-US': enUS,
    'zh-CN': zhCN
  })) || {
    intl: function intl(id) {
      return zhCN[id];
    }
  },
  intl = _ref.intl,
  getLocale = _ref.getLocale;
export { intl, enUS, zhCN, getLocale };